import { uniqueId } from 'lodash';
import React, { useRef } from 'react';

import Translation from '@swf/components/Translation/Translation';
import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import useTrackers from '@swf/core/hooks/useTrackers';
import useTrackingLabel from '@swf/core/hooks/useTrackingLabel';
import { Icon } from '@swf/sports/components';

import { TXTCLI_Clear, TXTCLI_Search, TXTWCL_Find_market_by_nameXX } from './Search.messages.json';
import styles from './Search.scss';

interface Props {
  searchTerm: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
}

const Search: React.FC<Props> = ({ searchTerm, onChange, onClear }) => {
  const { current: inputId } = useRef(uniqueId('search'));
  const { inputFocused } = useTrackers();
  const trackingLabel = useTrackingLabel(TXTWCL_Find_market_by_nameXX);
  const { formatMessage } = useRegulatoryIntl();

  return (
    <div className={styles.search}>
      <label htmlFor={inputId} className={styles.label}>
        <Translation {...TXTWCL_Find_market_by_nameXX} />
      </label>
      <div className={styles.inputWrapper}>
        {searchTerm ? (
          <button type="button" onClick={onClear} className={styles.iconWrapper}>
            <Icon
              name="close-medium"
              className={styles.clearIcon}
              label={formatMessage(TXTCLI_Clear)}
              size="lg"
            />
          </button>
        ) : (
          <div className={styles.iconWrapper}>
            <Icon
              name="search"
              className={styles.searchIcon}
              label={formatMessage(TXTCLI_Search)}
              size="lg"
            />
          </div>
        )}
        <input
          className={styles.input}
          id={inputId}
          onFocus={() => inputFocused({ fieldName: trackingLabel, fieldType: 'text' })}
          onChange={onChange}
          placeholder={formatMessage(TXTWCL_Find_market_by_nameXX)}
          type="text"
          value={searchTerm}
          title={formatMessage(TXTCLI_Search)}
        />
      </div>
    </div>
  );
};

export default Search;
